import React, { useEffect } from 'react';
import {
  Container,
  Heading,
  Section,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import { useParams, useHistory } from 'react-router-dom';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { AddEditParentAdminForm } from 'src/components/enterprise/Parents/Admin/AddParentAdminController/AddEditParentAdminForm/AddEditParentAdminForm';
import { IAddEditParentAdminFormData } from 'src/components/enterprise/Parents/Admin/types';
import { useGetAdminById } from 'src/components/enterprise/Parents/Admin/hooks/useGetAdminById/useGetAdminById';
import { useEditParentAdmin } from 'src/components/enterprise/Parents/Admin/hooks/useEditParentAdmin/useEditParentAdmin';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { useGetParentAccountsRedirectUrl } from 'src/components/enterprise/Parents/Admin/hooks/useGetParentAccountsRedirectUrl/useGetParentAccountsRedirectUrl';

export const EditParentAdminController: React.FC = () => {
  const { corpid: corpId, dinerId } =
    useParams<{ corpid: string; dinerId: string }>();
  const { push } = useHistory();

  const { diner } = useGetAdminById(corpId, dinerId);

  const useFormProps = useForm<IAddEditParentAdminFormData>({
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      internalId: '',
      ssoUniqueIdentifier: '',
      corpSsoIdentifierType: null,
    },
    mode: 'onSubmit',
  });

  const parentAccountsUrl = useGetParentAccountsRedirectUrl();

  const { reset, handleSubmit } = useFormProps;

  useEffect(() => {
    if (!diner) {
      return;
    }

    reset({
      firstName: diner.first_name,
      lastName: diner.last_name,
      email: diner.email,
      phoneNumber: diner.phone_number,
      internalId: diner.internal_id,
      ssoUniqueIdentifier: diner.corp_diner_settings?.sso_unique_identifier,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [diner]);

  const parentAdminDetailsLink = `/corporate/enterprise/parents/${corpId}/admin/${dinerId}`;

  const { mutate } = useEditParentAdmin({
    onSuccess: () => {
      push(parentAdminDetailsLink);
    },
  });
  const onSubmit = (formData: IAddEditParentAdminFormData) => {
    mutate(corpId, dinerId, formData);
  };

  const onCancel = () => {
    push(parentAdminDetailsLink);
  };

  return (
    <Container variant="default">
      <Section inset="sm">
        <PageHeader>
          <Stack y="sm">
            <Heading variant="h2">Edit parent admin</Heading>
          </Stack>
          <Breadcrumbs
            breadcrumbs={[
              parentAccountsUrl,
              {
                label: 'Parent admins',
                href: `/corporate/enterprise/parents/${corpId}/admin`,
                useRouterLink: true,
              },
              {
                label: 'Admin',
                href: `/corporate/enterprise/parents/${corpId}/admin/${dinerId}`,
                useRouterLink: true,
              },
            ]}
          />
        </PageHeader>
        <FormProvider {...useFormProps}>
          <AddEditParentAdminForm
            onSubmit={handleSubmit(onSubmit)}
            onCancel={onCancel}
            submitButtonText="Save changes"
            isEditing
          />
        </FormProvider>
      </Section>
    </Container>
  );
};
